/**************************************************
 * Nombre:       Detalle_Relacionados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import ListaProductos from "./SubComponentes/ListaProductos";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Detalle_Relacionados = () => {
    const {sCell} = useResponsive()

    const cargarMas = () => {

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{color: '#737373', fontSize: sCell ? 16 : 18, fontWeight: 400}}>Puede
                                interesarte</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                color: '#252B42',
                                fontSize: sCell ? 32 : 40,
                                fontWeight: 800,
                                textAlign: sCell ? 'center' : 'left',
                                lineHeight: 1.2
                            }}>Productos
                                Relacionados</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                            <ListaProductos items={items} cargaMas={cargarMas}/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Relacionados

const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]